import { useContext, useMemo } from 'react'

import { CartContext } from '../../Cart.vm'

export const useViewModel = () => {
    const {
        items,
        defaultRegion,
        cartActor: [state, send],
    } = useContext(CartContext)

    const shippingMethods = state.context.cart?.shipping_methods || []

    const onNext = () => {
        send({ type: 'NEXT' })
    }

    return {
        items: items || {},
        total: state.context.cart?.total || 0,
        shippingMethods,
        onNext,
    }
}
